
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderTransactionReportGrid extends Serenity.EntityGrid<OrderTransactionReportRow, any> {
        protected getColumnsKey() { return OrderTransactionReportColumns.columnsKey; }
        protected getDialogType() { return OrderTransactionReportDialog; }
        protected getIdProperty() { return OrderTransactionReportRow.idProperty; }
        protected getInsertPermission() { return OrderTransactionReportRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderTransactionReportRow.localTextPrefix; }
        protected getService() { return OrderTransactionReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}